import { Nav, NavItem } from "reactstrap";
import { useState } from "react";
import { SIDE_BAR_DATA } from "../../Data/Contacts";
import { Href } from "../../Constant";
import { ContactNavPropsType } from "../../Type/ContactType";
import CreateContact from "./CreateContact";
import CategoryCreate from "./CategoryCreate";

const NavComponent = ({ callbackActive }: ContactNavPropsType) => {
  const [activeTab, setActiveTab] = useState("1");
  
  const activeTabHandler=(value:string)=>{
    setActiveTab(value)
    callbackActive(value)
  }

  return (
    <Nav className="main-menu contact-options" role="tablist">
      <NavItem>
        <CreateContact />
      </NavItem>
      <NavItem><span className="main-title">Views</span></NavItem>
      <NavItem>
        <a href={Href} className={activeTab === "1" ? "active" : ""} onClick={() => { setActiveTab("1"); callbackActive("1");}}>
          <span className="title">Personal</span>
        </a>
      </NavItem>
      <NavItem>
        <CategoryCreate />
      </NavItem>
      {SIDE_BAR_DATA.map((data, index) => (
        <NavItem key={index}>
          <a href={Href} className={activeTab === data.value ? "active" : ""} onClick={() => activeTabHandler(data.value)}>
            <span className="title">{data.tittle}</span>
          </a>
        </NavItem>
      ))}
    </Nav>
  );
};

export default NavComponent;
